import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import StringCell from '@/backgrid/StringCell';
import DollarCell from '@/backgrid/DollarCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplDesktopSummaryView from './DesktopSummaryView.hbs';

import './DesktopSummaryView.css';

const DesktopSummaryView = View.extend({
  template: tmplDesktopSummaryView,

  className: 'desktop-summary-view',

  ui: {
    summaryTable: '.summary-table'
  },

  regions: {
    summaryTable: '@ui.summaryTable'
  },

  onRender() {
    this.columns = [
      {
        name: 'item',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'quantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'totalPrice',
        label: 'Total Price',
        cell: DollarCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      }
    ];

    this.collection = new Backbone.Collection([
      {
        item: 'Printer',
        quantity: this.model.get('order').totalPrinterQuantity,
        totalPrice: this.model.get('order').totalPrinterPrice
      },
      {
        item: 'Toner',
        quantity: this.model.get('order').totalTonerQuantity,
        totalPrice: this.model.get('order').totalTonerPrice
      },
      {
        item: 'Scanner',
        quantity: this.model.get('order').totalScannerQuantity,
        totalPrice: this.model.get('order').totalScannerPrice
      },
      {
        item: 'Order Total',
        quantity: this.model.get('order').totalOrderQuantity,
        totalPrice: this.model.get('order').totalOrderPrice
      }
    ]);

    this.orderSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.collection,
      columns: this.columns
    });
    this.showChildView('summaryTable', this.orderSummaryGridView);
  }
});

export default DesktopSummaryView;
